export const page_title = 'Locations';
export const page_subtitle =
  'Company addresses stored for easy deliveries to the office.';

export const add_title = 'Add an address';
export const edit_title = 'Edit an address';

export const cta_title = 'Add locations to manage delivery addresses';
export const cta_subtitle =
  'Your employees can easily select the company address for their corporate orders.';

export const deleteDialogContent =
  'Deleting this location might affect the allowances linked to it. Delete anyway?';
